<template>
  <div v-if="screens.length > 0">
    <div class="admin__header">
      <div>
        <h1 class="no-margin">Screens</h1>
        <div class="page__subtitle">{{ activeWorkflow.title }}</div>
      </div>
      <div class="actions">
        <router-link :to="previewRoute"
          class="actions__action secondary-button">
          Preview Workflow
        </router-link>
        <router-link :to="newScreenRoute" class="actions__action secondary-button">
          Add Screen
        </router-link>
      </div>
    </div>
    <div class="list-view list-view--stack-wide list-view--admin-screens">
      <div class="list-view__header">
        <div class="list-view__small-column">Position</div>
        <div>Title</div>
        <div class="list-view__small-column">Allow Multiple</div>
        <div class="list-view__small-column">Actions</div>
      </div>
      <div class="list-view__row" v-for="(screen, index) in sortedScreens" :key="screen.id">
        <div class="list-view__small-column">
          <span class="show-for-small">Position: </span>
          {{ screen.position }}
        </div>
        <div>
          <router-link :to="fieldsRoute(screen.id)">
            {{ screen.title }}
          </router-link>
        </div>
        <div class="list-view__small-column">
          <span class="show-for-small">Allow Multiple: </span>
          <i class="fa-solid fa-check" v-if="screen.allow_multiple" />
          <i class="fa-solid fa-xmark" v-else />
        </div>
        <div class="list-view__small-column list-actions list-actions--stacked">
          <div class="list-actions__group">
            <button class="icon-button list-action" @click="alterPosition(screen.id, screen.position - 1)"
              :disabled="index === 0">
              <i class="fa-solid fa-arrow-up" />
              <span class="list-action__label">Move Up</span>
            </button>
            <button class="icon-button list-action" @click="alterPosition(screen.id, screen.position + 1)"
              :disabled="index === sortedScreens.length - 1">
              <i class="fa-solid fa-arrow-down" />
              <span class="list-action__label">Move Down</span>
            </button>
          </div>
          <div class="list-actions__group">
            <router-link :to="editScreenRoute(screen.id)" class="list-action">
              <i class="fa-solid fa-pen-to-square" />
              <span class="list-action__label">Edit</span>
            </router-link>
            <button class="icon-button list-action" @click="deleteScreen(screen)">
              <i class="fa-solid fa-trash" />
              <span class="list-action__label">Delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <no-items v-else :parent="activeWorkflow.title" name="Screen" icon="desktop" new-link="admin-new-screen" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import clone from 'lodash.clone';
import Common from '@/common';
import NoItems from '@/components/NoItems';

export default {
  name: 'admin-screens',

  components: { NoItems },

  computed: {
    ...mapState({
      screens: state => state.admin.screen.screens,
    }),

    ...mapGetters('admin', [
      'activeWorkflow',
    ]),

    sortedScreens() {
      const screens = clone(this.screens);
      return screens.sort((a, b) => a.position > b.position);
    },

    contextQuery() {
      return Object.keys(this.$route.query).length > 0 ? this.$route.query : null;
    },

    previewRoute() {
      const route = { name: 'admin-preview-workflow', params: { globalWorkflowId: this.activeWorkflow.id } };
      if (this.contextQuery) route.query = this.contextQuery;
      return route;
    },

    newScreenRoute() {
      const route = { name: 'admin-new-screen' };
      if (this.contextQuery) route.query = this.contextQuery;
      return route;
    },
  },

  methods: {
    fieldsRoute(screenId) {
      const route = { name: 'admin-fields', params: { screenId } };
      if (this.contextQuery) route.query = this.contextQuery;
      return route;
    },

    editScreenRoute(screenId) {
      const route = { name: 'admin-edit-screen', params: { screenId } };
      if (this.contextQuery) route.query = this.contextQuery;
      return route;
    },

    deleteScreen(screen) {
      Common.confirmDialog({
        modal: this.$modal,
        title: `Are you sure you want to delete ${screen.title}?`,
        okHandler: () => {
          this.$store.dispatch('admin/deleteScreen', {
            workflowId: this.activeWorkflow.id,
            screenId: screen.id,
          });
        },
      });
    },

    alterPosition(screenId, position) {
      this.$store.dispatch('admin/editScreen', { data: { id: screenId, position }, noCommit: true })
        .then(() => this.$store.dispatch('admin/fetchScreens', { dependsOn: this.activeWorkflow.id, override: true }));
    },
  },
};
</script>
